<template>
    <div>
      <img style="width: 100%;" src="@/assets/images/compliance/daping.png">
    </div>
</template>
<script>
    export default {
        data() {
            return {
                // 公告列表数据
                dataList: [],
                pageSize: 10,
            };
        },
        mounted() {
        },
        methods: {
          turnPage(i){
            switch (i) {
              case 1:
                window.open("https://www.hnzwfw.gov.cn/portal/department/001003025002044?region=411500000000&creditCode=1241150000606761X1", '_blank')
                break
              case 2:
                break
              case 3:
                let text= this.$router.resolve({
                  path: '/jiuyeqiuzhi'
                });
                window.open(text.href, '_blank')
                break
              case 4:
                break
              case 5:
                window.open("https://www.hnzwfw.gov.cn/portal/department/001003025002020?region=411500000000&creditCode=11411500561048661G", '_blank')
                break
              case 6:
                window.open("http://bmfw.haedu.gov.cn/", '_blank')
                break
              case 7:
                let text1= this.$router.resolve({
                  path: '/zhaopinxinxi'
                });
                window.open(text1.href, '_blank')
                break
              case 8:
                let text2= this.$router.resolve({
                  path: '/zhiyexuexiao'
                });
                window.open(text2.href, '_blank')
                break
              case 9:
                let text3= this.$router.resolve({
                  path: '/daping'
                });
                window.open(text3.href, '_blank')
                break
              default:
                break
            }

          }
        },
    };
</script>
<style lang="scss" scoped>
@charset "utf-8";
/* LLK CSS Document */
*{ margin:0px; padding:0px; color: #535353;font-family: 微软雅黑; font-size:14px;box-sizing: border-box;outline: none}
html, body { height: 100%; min-width: 1002px; }
fieldset, img { border: 0; }
li { list-style: none; }
a { color: #535353; text-decoration: none; }
a:hover { color: #0473d9;transition: all 0.2s ease-in-out 0s;}
table { border-collapse: collapse; border-spacing: 0; }
.table_fix { table-layout: fixed; }
.clear { clear: both; line-height: 0px; font-size: 0px; height: 0px }
.clearfix:before, .clearfix:after { content: ""; display: table; }
.clearfix:after { clear: both; overflow: hidden; }
.clearfix { *zoom:1;
}
.zong_tagContent .tagContent { display: none; }
.zong_tagContent .selectTag { display: block; }
.rel { position: relative }
.abs { position: absolute }
.align_c { text-align: center }
.f_l { float: left }
.f_r { float: right }
.webbox{}
.webbox_bj1{background: url("../../../assets/images/compliance/shouye.png") no-repeat center top;height: 850px}
.webbox_bj2{height: 200px;width: 1200px;}
.webbox_bj3{background: url("../../../assets/images/compliance/jiuyeqiuzhi.png") no-repeat center top;height: 850px}
.webbox_bj4{background: url("../../../assets/images/compliance/jiuyeqiuzhixiangqing.png") no-repeat center top;height: 850px}
.webbox_bj5{background: url("../../../assets/images/compliance/zhiyexuexiao.png") no-repeat center top;height: 850px}
.webbox_bj6{background: url("../../../assets/images/compliance/zhiyexuexiaoxiangqing.png") no-repeat center top;height: 850px}
.webbox_bj7{background: url("../../../assets/images/compliance/zhaopin.png") no-repeat center top;height: 850px}
.webbox_bj8{background: url("../../../assets/images/compliance/zhaopinxingqing.png") no-repeat center top;height: 850px}
.webbox_con{width: 1200px;position: relative;margin: 0px auto;}
.shouye{display: inline-block;position: absolute;width: 300px;height: 40px;top:0px;left: -307px;}
.qitafuwu{width: 600px;height: 310px;position: relative;/*! background: #ddd; */top:1229px;left: 0px;}
.qitafuwu a{display: inline-block;position: absolute;background-color: rgba(255,255,255,0)}
.weblink1{width:60px;height: 40px;top:3px;right: 11px; }
.weblink2{width:174px;height: 174px;top:86px;left: 20px; }
.weblink3{width:174px;height: 174px;top:86px;left:210px; }
.weblink4{width:174px;height: 174px;top:86px;left:403px; }
.qitafuwu a:hover{background-color: rgba(255,255,255,0.25)}
.weblink5{width:266px;height: 143px;top:329px;left:272px; display: inline-block;position: absolute;background-color: rgba(255,255,255,0)}
.weblink6{width:360px;height: 120px;top:290px;left:40px;display: inline-block;position: absolute; background-color: rgba(255,255,255,0)}
.weblink7{width:1200px;height: 120px;top:250px;left:0px;display: inline-block;position: absolute;background-color: rgba(255,255,255,0) }
.weblink5:hover,.weblink6:hover,.weblink7:hover{background-color: rgba(255,255,255,0.15)}

.zcjsq_banner {
  width: 100%;
  height: 12.5rem;
  background: url("~@/assets/images/sub_banner.png") no-repeat 100% / cover;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: #fff;
    font-weight: 600;
    font-size: 1.375rem;
    margin-left: -24%;
  }
  .input-search-bar {
    height: 55px;
    width: 50%;
    margin: auto;
    margin-top: -20px;
    border-radius: 4px;
    background: #ffffff;
    display: flex;
    margin-top: 40px;
    ::v-deep .el-input__inner {
      border: none !important;
      height: 55px;
      line-height: 55px;
    }
    /* 输入框头部 */
    .input-search-pre {
      width: 120px !important;
      color: #404040;
      font-size: 16px;
      .el-input__inner {
        text-align: center !important;
        border: none !important;
        border-radius: 0 !important;
        color: #333;
        background-color: #ffffff !important;
      }
    }

    /* 输入框内容 */
    .input-search {
      flex: 1;
      .el-input__inner {
        border: none !important;
        border-radius: 0 !important;
        background-color: #ffffff !important;
        font-size: 18px;
      }
      input::-webkit-input-placeholder {
        color: #999999;
      }
    }
    /* 输入框按钮 */
    .input-search-btn {
      background: #e60000;
      height: 100%;
      width: 100px;
      border-radius: 0 !important;
      border-top-right-radius: 4px !important;
      border-bottom-right-radius: 4px !important;
      border: 2px solid #b6a99c !important;
      text-align: center;
      cursor: pointer;
      .el-button {
        font-weight: bold !important;
      }
    }
  }
}

.nimg{
  width: 350px;
}

.imgs{
  width: 250px;
}


  </style>
